import {
    get,
    post,
    post2,
    put,
    put2,
    $delete
} from '@/plugins/axios.js'

export default {
    post(params) {
        return post2('/api/application', params);
    },
    copy(params) {
        return post('/api/application/copy', params);
    },
    delete(id, params) {
        return $delete(`/api/application/${id}`, params);
    },
    put(params) {
        return put('/api/application', params);
    },
    findById(params) {
        return get('/api/application', params);
    },
    list(params) {
        return get('/api/application/list', params);
    },
    triggerList(applicationId) {
        return get('/api/application/triggerList?applicationId=' + applicationId)
    }


}
